import { Close } from '@mui/icons-material';
import { ModalProps } from 'interfaces/ModalProps';

const Modal: React.FC<ModalProps> = ({
  open,
  onClose,
  className,
  modalContainerClass,
  showCloseIcon = true,
  children,
}) => {
  return open ? (
    <div
      className={`close-modal  fixed left-0 top-0 flex h-full w-full  items-center justify-center bg-white p-5 ${modalContainerClass}`}
    >
      <div
        className={`flex w-full max-w-[500px] animate-zoom-in flex-col space-y-5 rounded-md bg-white p-8 drop-shadow-md ${className}`}
      >
        {showCloseIcon && (
          <div className="cursor-pointer self-end">
            <Close onClick={onClose} />
          </div>
        )}

        {children}
      </div>
    </div>
  ) : (
    <></>
  );
};

export default Modal;
